import { gql } from 'apollo-boost';

export const indicatorsQuery = gql`
query {
  allIndicators(filters: {version: "v4"}) {
    edges {
      node {
        dbId
        name
        stageId
        stgName
        definition
        guidance
        version
        customizable
        measurementTypeId
        measurementType {
          name
        }
        benchmarkType
        services {
          edges {
            node {
              dbId
              name
            }
          }
        }
        tags
      }
    }
  }
}
`;
